<div class="main-content">
  <div class="container-fluid">
    <!-- <h4 class="h4">(Courier Charges)</h4> -->

    <!-- Campo de búsqueda mejorado con autocompletado -->
    <!-- <br /><br /><br /> -->

    <div class="card-tools">
      <div class="row">
        <div class="col-12">
          <a
            [routerLink]="['/documents/add']"
            class="btn btn-dark btn-sm btn-new"
          >
            Upload
          </a>
        </div>
      </div>
    </div>

    <div class="card shadow-sm">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="thead">
              <tr>
                <th>Name</th>
                <th class="th__status">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredData">
                <!-- <td>{{ item.name }}</td> -->
                <!-- <a [href]="apiUrl + '/' + item.filename" download>
 -->
                <td>
                  <a [href]="apiUrl + '/' + item.filename" target="_blank">{{
                    item.name
                  }}</a>
                </td>
                <td>
                  <button
                    (click)="deleteData(item._id)"
                    class="btn btn-link text-dark btn-sm btn-del"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
